import {
  fetchBlogCategories,
  fetchBlogIndex,
  fetchBlogPosts
} from '../../services/contentfulPosts'
import * as React from 'react'
import type { AppStateType } from '../../reducers/appstate'
import type { Dispatch } from 'redux'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import type {
  BlogPostType,
  BlogCategoryType,
  BlogIndexPageType,
  FetchBlogPostsQueryParamsType
} from '../../services/contentfulPosts'
import HtmlHead from '@components/HtmlHead'
import BlogHeader from '@components/blog/BlogHeader'
import { Col, Container, Row } from 'react-awesome-styled-grid'
import FeaturedBlog from '@components/blog/FeaturedBlog'
import ThreeHorizontalPosts from '@components/blog/ThreeHorizontalPosts'
import LatestBlogs from '@components/blog/Latest'
import SectionTitle from '@components/blog/SectionTitle'
import { colors, GlobalStyle } from '@components/shared'
import Footer from '@components/Footer'
import TopNav from '@components/TopNav'
import styled from 'styled-components'
import TopNavMobile from '@components/TopNavMobile'
import BlogEmailCaptureModal from '@components/blog/BlogEmailCaptureModal'
import DriveToDownload from '@components/DriveToDownload'
import BackgroundGradient from '@components/BackgroundGradient'

type PropsType = {
  categories: BlogCategoryType[],
  indexPage: BlogIndexPageType,
  blogPosts: BlogPostType[],
  queryParams: FetchBlogPostsQueryParamsType
}

function Blog ({ categories, indexPage, blogPosts, queryParams }: PropsType): React.ReactNode {
  const [blogs, setBlogs] = React.useState<BlogPostType[]>(blogPosts)

  const readMore = async (skip: number = 0): Promise<void> => {
    const newBlogs = await fetchBlogPosts({ ...queryParams, skip })
    setBlogs(blogs.concat(newBlogs))
  }
  return (
    <ContainerDiv>
      <BlogContainer>
        <BackgroundImageContainer>
          <BackgroundGradient
            quadrant={2}
            gradientColor={colors.violet}
            overlayColor='magenta'
            gradientPosition='bottom'
            parallax
          />
          <HtmlHead
            title={'Dipsea | Blog'}
            description={'Dive deeper into the Dipseaverse with behind-the-scenes looks at our process, reflections from our community, and thoughtful investigations into what\'s turning us on and why.'}
          />
          <GlobalStyle backgroundColor={colors.violet} />
          <TopNav backgroundColor={colors.violet95} isAssetLoaded={true} isBlog={true} />
          <TopNavMobile backgroundColor={colors.violet95} isAssetLoaded={true} isBlog={true} />
          <BlogEmailCaptureModal />
          <Container>
            <BlogHeader categories={categories} title={indexPage.title} subtitle={indexPage.subtitle} />
            <FeaturedBlog post={indexPage.featuredBlog} />
            <Row>
              <Col xs={4} sm={8} lg={10} offset={{ lg: 1, xl: 1 }}>
                <SectionTitle title={'Most Popular'} />
              </Col>
              <Col xs={4} sm={8} lg={10} offset={{ lg: 1, xl: 1 }}>
                <ThreeHorizontalPosts blogs={indexPage.mostPopular} />
              </Col>
            </Row>
          </Container>
        </BackgroundImageContainer>

        <Container>
          <LatestBlogs blogs={blogs} readMore={readMore} />
        </Container>

        <Container>
          <Row align='center' justify='center'>
            <Col>
              <DriveToDownload dontShowPhoneImage />
            </Col>
          </Row>
        </Container>
      </BlogContainer>
      <Footer backgroundColor={colors.midnightBlue} />
    </ContainerDiv>
  )
}

export async function getStaticProps (): Promise<{ props: PropsType }> {
  const [indexPage, categories] = await Promise.all([fetchBlogIndex(), fetchBlogCategories()])
  const excludeIds = indexPage.mostPopular.map((item: BlogPostType): string => item.id)
  excludeIds.concat([indexPage.featuredBlog.id])
  const queryParams = { excludeIds, limit: 5 }
  const blogPosts = await fetchBlogPosts({ excludeIds, limit: 5 })

  return {
    props: {
      categories,
      indexPage,
      blogPosts,
      queryParams
    }
  }
}

const mapStateToProps = (state: AppStateType, ownProps: PropsType): any => {
  return {
    ...ownProps
  }
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Blog) as any) as any

const ContainerDiv = styled.div<any>`
  width: 100%;
  height: 100%;
  position: relative;
`

const BlogContainer = styled.div<any>`
  position: relative;
  z-index: 10;
  div.SectionTitle {
    margin: 0;
  }
`

const BackgroundImageContainer = styled.div<any>`
  position: relative;
`
